import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { RowStatus } from '../../../common/enums/row-status.enum';
import { AuthorizationPipe } from '../../../common/pipes/authorization.pipe';
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { UserInfo } from '../../../shared/interface/user-info.interface';
import { CacheService } from '../../../shared/services/cache.service';
import { CommonService, CommonService as SharedCommonService } from '../../../shared/services/common.service';
import { Utils } from '../../../shared/Utils/utils';
import { CommonMessage } from '../../common/common-messages';
import { OperatingCountryEnums } from '../../enums/countries.enums';
import { NotificationType } from "../../enums/notification-types.enum";
import { IDepartment } from '../../interface/department';
import { DepartmentDuty } from '../../interface/department-duty';
import { DeleteModal } from '../../models/delete-modal';
import { CustomerService } from '../../services/customer.service';
import { DepartmentService } from '../../services/department.service';
import { Modal } from 'ngx-modal';


@Component({
    selector: 'department',
    templateUrl: '../../templates/template1/views/department/department.component.html',
    styleUrls: ['../../templates/template1/themes/default/css/department.less'],
    providers: [AuthorizationPipe]
})
export class DepartmentComponent implements OnInit {
    @Input() departmentId: number;
    @ViewChild('emailUpdateConfirmation') emailUpdateConfirmation: Modal;
    isUpdateDept: boolean =false;
    department: IDepartment;
    deleteModal: DeleteModal;
    public departmentForm: FormGroup;
    countries: any;
    message: string;
    ticketTypes: any[];
    userInfo: UserInfo;
    duties: DepartmentDuty[] = [];
    isSubmitted: boolean = false;
    showText:boolean=true;
    isCountriesLoading = false;

    constructor(private router: Router,
        private departmentService: DepartmentService,
        private _formbuilder: FormBuilder,
        private sharedCommonService: SharedCommonService,
        private _commonService: CommonService,
        private _translatePipe: TranslateService,
        private _cacheService: CacheService,
        private _customerservice: CustomerService) {
    }

    ngOnInit() {
        if (environment.dataLayer && environment.dataLayer.length > 0) {
            environment.dataLayer[0].pageCategory = 'departments';
        }
        this.setFocusToTextBox();
        this.getOperatingCountries();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.buildForm();
        this.deleteModal = new DeleteModal(this.clearForm.bind(this),
            this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = true;
        this.departmentId ? this.getDepartmentInfo():null;
    }
    setFocusToTextBox(){
        setTimeout(function(){ 
            const autoFocusElement = document.getElementById('autofocus-element');
            if (autoFocusElement) {
                autoFocusElement.focus();
            }
         }, 200);
    }

    backToDepartmentearch() {
        this.router.navigate(['/customerservice/departments/search']);
    }
    sortNumber(a: any, b: any) {
        return a - b;
    }
    getDepartmentInfo() {
        this.departmentService.getDepartmentById(this.departmentId)
            .subscribe(response => {
                if (response) {
                    this.department = response;
                    if (this.departmentId > 0) {
                        this.bindData();
                    }
                    this.showText = false;
                    this.isUpdateDept = true;
                }
            });
    }
    bindData(): void {
        this.departmentForm.patchValue({
            operatingCountryId: this.department.operatingCountryId,
            name: this.department.name,
            email: this.department.email,
            status:(this.department.status == RowStatus.Active) ?true:false,
        });
        this.departmentForm.controls['operatingCountryId'].setValidators(null)
        this.departmentForm.controls['operatingCountryId'].updateValueAndValidity();
        this.departmentForm.controls['operatingCountryId'].disable();
        const autoFocusElement = document.getElementById('autofocus-name-element');
        if (autoFocusElement) {
            autoFocusElement.focus();
        }

    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof DepartmentComponent
     */
    getTicketTypesAndSubTypes() {
        this.ticketTypes = [];
        this.duties = [];
        let operatingCountry = this.departmentId > 0 ? this.department.operatingCountryId : this.departmentForm.controls['operatingCountryId'].value;
        if (operatingCountry) {
            this.departmentService.getTicketTypesAndSubTypes(operatingCountry).subscribe(response => {
                if (response) {
                    this.ticketTypes = response;
                    if (this.departmentId > 0) {
                        this.bindData();
                        this.showText = false;
                    } else {
                        this.showText = false;
                    }
                }
            });
        }
    }

    getTicketTypes() {
        this.departmentService.getTicketTypes().subscribe(response => {
            if (response) {
                this.ticketTypes = response;
            }
        });
    }

    alertOnClearingOfData() {
        this.setFocusToTextBox();
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.clearFormData;
    }

    clearForm() {
        if (this.departmentId > 0) {
            this.bindData();
          } else {
            this.departmentForm.reset();
            this.isSubmitted = false;
            this.showText = true;
            this.departmentForm.controls['operatingCountryId'].setValue(''); 
            this.duties = [];
        }
    }

    doNotRemoveFormData() {
        //data should not be removed...
    }

    buildForm() {
        const  emailPattern  =  '^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$';
        this.departmentForm = this._formbuilder.group({
            operatingCountryId: ['', Validators.required],
            name: ['', [Validators.required, Utils.noEmptyString, Utils.allowedSpecialCharacterRule([':', '_', '-'])]],
            email: ['', [Utils.noEmptyString, ,Validators.pattern(emailPattern),Validators.required]],
            status: [true]
        });
    }

    saveDepartment(department: IDepartment) {
        department.loggedInUserId = this.userInfo.userId;
        let country: any = this.countries.find((item: any) => item.id === +department.operatingCountryId);
        if (country) {
            department.operatingCountryName = country.name;
        }
        department.status = department.status? RowStatus.Active:RowStatus.Inactive;
        department.whiteListed = false;

        this.departmentService.saveDepartment(department)
            .subscribe(response => {
                if (response.success === true) {
                    let created: any = this._translatePipe.get('Department has been Created successfully');
                    this.message = 'Department has been Created successfully.';
                    this.isSubmitted = false;
                    this._commonService.createNotification('', created.value, NotificationType.SUCCESS);
                    this._commonService.getUserInformation(this.userInfo.userName).subscribe(data => {
                    if (data) {
                            this._cacheService.set(CacheKey.UserInfo, data);
                    }
                    });
                    this.clearForm();
                    this.buildForm();
                    this.showText = true;
                } else {
                    let failed: any =[];
                    if (response.validations.length > 0) {
                        response.validations.forEach(item => {
                            this.message = item.message;
                            this._commonService.createNotification('',  this.message, NotificationType.ERROR);
                        });
                    } else {
                        failed = this._translatePipe.get('Your attempt to create Department is failed');
                        this.message = 'Your attempt to create Department is failed.';
                        this._commonService.createNotification('', failed.value, NotificationType.ERROR);
                    }
                }
            }
            , error => (
                this.message = error[0].message,
                this.sharedCommonService.createNotification('', this.message, NotificationType.ERROR)
            ));
    }


    updateDepartment(department: IDepartment) {
        let deptValues = this.departmentForm.getRawValue();
        department.loggedInUserId = this.userInfo.userId;
        department.id = this.departmentId;
        department.operatingCountryId = this.department.operatingCountryId;       
        department.status = deptValues.status? RowStatus.Active:RowStatus.Inactive;
        department.whiteListed = this.department.whiteListed;
        let country: any = this.countries.find((item: any) => item.id === +department.operatingCountryId);
        if (country) {
            department.operatingCountryName = country.name;
        }
        this.departmentService.updateDepartment(department)
            .subscribe(response => {
                if (response.success === true) {
                    let created: any = this._translatePipe.get('Department has been Updated successfully');
                    this.message = 'Department has been Updated successfully.';
                    this.isSubmitted = false;
                    this._commonService.createNotification('', created.value, NotificationType.SUCCESS);
                }
                else {
                    let failed: any =[];
                    if (response.validations.length > 0) {
                        response.validations.forEach(item => {
                            this.message = item.message;
                            this._commonService.createNotification('',  this.message, NotificationType.ERROR);
                        });
                    } else {
                        failed = this._translatePipe.get('Your attempt to Update Department is failed');
                        this.message = 'Your attempt to Update Department is failed.';
                        this._commonService.createNotification('', failed.value, NotificationType.ERROR);
                    }
                }
            }
            , error => (
                this.message = error.validations[0].message,
                this.sharedCommonService.createNotification('', this.message, NotificationType.ERROR)
            ));
    }

    /**
     * @description
     * @date 2020-03-05
     * @param {*} departmentForm
     * @param {*} [valid]
     * @memberof DepartmentComponent
     */
    onSubmit(departmentForm: any,valid?:any) {
        this.isSubmitted = true;
        if (this.departmentForm.valid) {
            if (this.departmentId > 0) {
                    window.document.getElementById('update-button').classList.add('button-active');
                    setTimeout(() => {
                       window.document.getElementById('update-button').classList.remove('button-active');
                    }, 1000);
                    this.updateConfirmation();
                    //this.updateDepartment(this.departmentForm.value);
            } else {
                window.document.getElementById('search-button').classList.add('button-active');
                    setTimeout(() => {
                        window.document.getElementById('search-button').classList.remove('button-active');
                    }, 1000);
                this.saveDepartment(this.departmentForm.value);
            }
        }

    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof DepartmentComponent
     */
    getOperatingCountries() {
        this.isCountriesLoading = true;
        this._customerservice.getAllBusinessEntities().subscribe((response: any) => {
            if (response) {
                this.isCountriesLoading = false;
                this.countries = response;
                let countryInfo = this.countries.find((country:any) => country.id === OperatingCountryEnums.USA);
                if(countryInfo){
                    this.countries.splice( this.countries.indexOf(countryInfo), 1);
                    this.countries.splice(0, 0, countryInfo);
                }
            }
        },error => {
            this.isCountriesLoading = false;
        });
    }

    validateDepartmentsTypes(): Boolean {
        let isValid: Boolean = false;
        if (this.duties && this.duties.length > 0) {
            if (!this.duties.some(item => item.isTypeRequired === true || item.isSubTypeRequired === true)) {
                isValid = true;
            } else {
                this.duties.forEach(typeItem => {
                    typeItem.isTypeValidationRequired = ((typeItem.typeId && typeItem.typeId > 0) ? false : true);
                    typeItem.isSubTypeValidationRequired = ((typeItem.subTypeIds && typeItem.subTypeIds.length > 0) ? false : true);
                });
                isValid = false;
            }
        }
        return isValid;
    }

    /**
     * @description close modal
     * @returns void
     */
    closeModal(): void {
        this.bindData();
        this.emailUpdateConfirmation.close();
    }
    

    /**
     * @description open emailUpdateConfirmation modal
     * @returns void
     */
    updateConfirmation(): void {
        this.emailUpdateConfirmation.open();
    }

    updateDepartmentConfirmation(): void {
        this.emailUpdateConfirmation.close();
        this.updateDepartment(this.departmentForm.value);
    }
    
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/department/department.component.ts